<template>
  <div>
    <section class="sectionStyle">
      <img src="../../assets/imgs/shapes/bg-shape-1.png" class="GS_JJ_BG" alt="">
      <img src="../../assets/imgs/shapes/shape-7.png" class="GS_JJ_RH_1 float-bob-y" alt="">
      <img src="../../assets/imgs/shapes/shape-8.png" class="GS_JJ_RH_2 float-bob-y" alt="">
      <a-row class="GS_JJ_content_box "  type="flex" justify="space-between">
        <a-col :xs="24" :sm="24" :md="24" :lg="12">
        <!-- image area start -->
        <div class="about-us-image-area animate__animated animate__fadeInRightBig wow">
            <div class="border-shape"></div>
               <div class="image-1">
                  <img :src="tenantConfig.membeMaxImg ? tenantConfig.membeMaxImg : '../../assets/imgs/shapes/about-1.jpg'" style="width: 70%;height: 588px;object-fit: cover;" alt="">
               </div>
               <div class="image-2-area">
                  <div class="image-2 p-relative">
                     <img :src="tenantConfig.membeMinImg ? tenantConfig.membeMinImg : '../../assets/imgs/shapes/about-2.jpg'" style="width: 100%;height: 100%;" alt="">  
                     <div class="play-btn">
                        <div class="video_player_btn">
                           <a :href="tenantConfig.memberVideoUrl" target="_blank" class="popup-video"><i class="iconfont">&#xe867;</i></a>
                       </div>
                     </div>                                 
                  </div>                  
               </div>
               <div class="working-area float-bob-y">
                 <div class="inner p-relative">
                     <div class="icon-box">
                       <img :src="tenantConfig.memberFloatImg ? tenantConfig.memberFloatImg : '../../assets/imgs/shapes/about-2.jpg' " alt="">
                     </div>
                 </div>
               </div>
            </div>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="11">
          <div class="GS_JJ_content animate__animated animate__fadeInLeftBig wow" v-html="tenantConfig.memberText"></div>
        </a-col>
      </a-row>
     </section>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      tenantConfig:{}
    }
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo
  },
  mounted() {},
  methods: {}
}
</script>
<style lang='less' scoped>
.about-us-image-area .image-1 {
  position: relative;
  display: block;
  overflow: hidden;
}

.about-us-image-area .image-1:before {
  position: absolute;
  top: 0;
  left: -75%;
  display: block;
  content: '';
  width: 50%;
  height: 100%;
  background: -o-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .3) 100%);
  background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), to(rgba(255, 255, 255, .3)));
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .3) 100%);
  -webkit-transform: skewX(-25deg);
  -ms-transform: skewX(-25deg);
  transform: skewX(-25deg);
}

.GS_JJ_content_box:hover .image-1:before {
  animation: shine 1.5s;
}

@-webkit-keyframes shine {
100% {
  left: 125%;
}
}
@keyframes shine {
100% {
  left: 125%;
}
}
.image-2-area{
  width: 239px;
  height: 256px;
}

.GS_JJ_content{
  padding: 20px;
}
</style>
